import indigo from '@mui/material/colors/indigo';
import pink from '@mui/material/colors/pink';

export const theme = {
  palette: {
    primary: {
      light: indigo[300],
      main: indigo[500],
      dark: indigo[700],
      contrastText: '#fff',
    },
    secondary: {
      light: pink[300],
      main: pink['A200'],
      dark: pink[700],
      contrastText: '#fff',
    },
  },
  status: {
    danger: 'orange',
  },
  direction: 'ltr',
  typography: {
    button: {
      fontFamily: ['Roboto', 'Helvetica', 'Arial', 'Space Mono', 'sans-serif'],
      fontWeight: 400,
      textAlign: 'capitalize',
    },
  },
};
